/**
 * DreamPay Private API [DEPRECATED]
 * ⚠️ **DEPRECATED** - This API version is deprecated and will be removed on 2026-05-31. Please migrate to V2.  Private API v1 - Legacy endpoints for DreamPay payment processing platform.
 *
 * The version of the OpenAPI document: v1
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ReconciliationTransactionDto {
  id?: number;
  date?: string;
  tid?: string;
  authorizationCode?: string;
  proofSale?: string;
  totalValueBrl?: number;
  installments?: number;
  cardNumber?: string;
  cardType?: string;
  cardProcessingComission?: number | null;
  cardProcessingCostBrl?: number | null;
  antecipationComission?: number | null;
  antecipationCostBrl?: number | null;
  totalFeesRate?: number | null;
  totalFeesValue?: number | null;
  providerNetValue?: number | null;
  paid?: boolean;
  canceled?: boolean;
  providerReconciled?: boolean;
  establismentName?: string | null;
  customerName?: string | null;
  estimatedMarginPercentage?: number | null;
}
